import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[blogs]/page.js");
